<mat-toolbar color="accent">
  <button id="goToPanelButtonShowEdit" mat-icon-button (click)="goToPanel()">
    <mat-icon class="icon-ic_arrow_back" color="secundary"></mat-icon>
  </button>
  <span *ngIf="!isPrintOption">{{ 'signature.title' | translate }}</span>
  <span *ngIf="isPrintOption">{{ 'signature.print.title' | translate }}</span>
</mat-toolbar>

<mat-card>
  <h2 *ngIf="!isPrintOption">{{ 'signature.subtitle' | translate }} {{ numOperation }}</h2>
  <h2 *ngIf="isPrintOption">{{ 'signature.print.subtitle' | translate }} {{ numOperation }}</h2>
  <p *ngIf="!isPrintOption">{{ 'signature.text' | translate }}</p>
  <p *ngIf="isPrintOption">{{ 'signature.print.text' | translate }}</p>
  <div>
    <form [formGroup]="pendingForm">
      <div class="table__wrapper">
        <table aria-label="participants" mat-table [dataSource]="dataSource.data">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <!-- deshabilitar radio button cuando el interviniente haya finalizado la firma-->
              <ng-template [ngIf]="!isDisabled(element.document_result)">
                <mat-radio-group formControlName="pending">
                  <mat-radio-button
                    (click)="onClickRadioButton($event, element)"
                    (change)="$event ? selection.toggle(element) : null"
                    [checked]="selection.isSelected(element)"
                    [value]="element"
                  >
                  </mat-radio-button>
                </mat-radio-group>
              </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="dni">
            <th mat-header-cell *matHeaderCellDef translate>signature.dni</th>
            <td mat-cell *matCellDef="let element">{{ element.legalIdentity_id }} {{ element.businessCIF }}</td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef translate>signature.name</th>
            <td mat-cell *matCellDef="let element">
              {{ element.firstname }}
            </td>
          </ng-container>
          <ng-container matColumnDef="surname">
            <th mat-header-cell *matHeaderCellDef translate>signature.surname</th>
            <td mat-cell *matCellDef="let element">
              {{ element.lastname1 }}
            </td>
          </ng-container>
          <ng-container matColumnDef="surname2">
            <th mat-header-cell *matHeaderCellDef translate>signature.surname2</th>
            <td mat-cell *matCellDef="let element">
              {{ element.lastname2 }}
            </td>
          </ng-container>
          <ng-container matColumnDef="mobile">
            <th mat-header-cell *matHeaderCellDef translate>signature.mobile</th>
            <td mat-cell *matCellDef="let element">
              {{ element.mobile }}
            </td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef translate>signature.email</th>
            <td mat-cell *matCellDef="let element">
              {{ element.email }}
            </td>
          </ng-container>
          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef translate>signature.role</th>
            <td mat-cell *matCellDef="let element">
              {{ element.rol }}
            </td>
          </ng-container>
          <ng-container matColumnDef="guid">
            <th mat-header-cell *matHeaderCellDef translate>signature.guid</th>
            <td mat-cell *matCellDef="let element">
              {{ element.guid }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            [hidden]="isPrintOption && (row.consentAccepted || row.businessCIF != '')"
            *matRowDef="let row; columns: displayedColumns"
          ></tr>
        </table>
      </div>
    </form>
  </div>
</mat-card>
<div class="buttons" fxLayoutAlign="end" fxLayoutGap="16px">
  <button
    *ngIf="!isAsyncSignature"
    mat-flat-button
    color="accent"
    [disabled]="!pendingForm.valid"
    (click)="signClick()"
  >
    <mat-icon class="icon-ic_sign"></mat-icon>
    <span *ngIf="!isPrintOption">{{ 'signature.button' | translate | uppercase }}</span>
    <span *ngIf="isPrintOption">{{ 'signature.print.button' | translate | uppercase }}</span>
  </button>
  <button
    *ngIf="isAsyncSignature"
    mat-flat-button
    color="accent"
    [disabled]="!pendingForm.valid"
    (click)="sendEmailClick()"
  >
    <mat-icon class="icon-ic_inbox_message"></mat-icon>
    <span>{{ 'signature.async.send.email' | translate | uppercase }}</span>
  </button>
</div>
